import { forwardRef, Injectable } from '@angular/core';
import { DetailPhysicalAddress, SuggestedPhysicalAddress } from '@rd/types';
import {
  AddressFinderDetailAddressResponse,
  AddressFinderSuggestedAddressesResponse,
} from '@rd/types/physical-address.response';
import { Observable } from 'rxjs';
import { AddressFinderServiceApi } from '../address-finder/address-finder.api';

@Injectable({
  providedIn: 'root',
  useClass: forwardRef(() => AddressFinderServiceApi),
})
export abstract class PhysicalAddressApiService {
  abstract fetchSuggestAddresses(
    query: string,
  ): Observable<SuggestedPhysicalAddress[]>;

  abstract fetchDetailAddress(
    addressId: string,
  ): Observable<DetailPhysicalAddress | null>;

  abstract buildSuggestedAddressesUrl(query: string): string;

  abstract buildDetailAddressUrl(addressId: string): string;

  abstract transformSuggestedAddresses(
    data: AddressFinderSuggestedAddressesResponse,
  ): SuggestedPhysicalAddress[];

  abstract transformDetailAddress(
    data: AddressFinderDetailAddressResponse,
  ): DetailPhysicalAddress | null;
}
